<template>
  <div>
    <partHeader :title="title" :required="true">
      <div>
        <el-button type="primary" @click="add" v-show="!disabled"
          >+工作及学习培训简历</el-button
        >
      </div>
    </partHeader>
    <div v-show="disabled">
      <el-row v-for="(item, index) in form.resume" :key="index">
        <el-col :span="24">
          <el-input
            type="textarea"
            v-model="item.content"
            rows="4"
            :disabled="disabled"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <div v-show="!disabled">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="150px"
      >
        <el-form-item prop="resume" label-width="0px">
          <el-row v-for="(item, index) in form.resume" :key="index">
            <hr v-if="index > 0" />
            <el-row v-if="item.show">
              <el-col :span="8">
                <el-form-item label="时间：">
                  {{ item.startDate + "至" + item.endDate }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="地点：">
                  {{ item.location }}
                </el-form-item>
              </el-col>
              <el-col :span="2" :offset="4">
                <el-form-item label="">
                  <div class="modify" @click="modify(item)">修改</div>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item label="">
                  <div class="delete" @click="del(index)">删除</div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="工作及培训学习内容：">
                  {{ item.content }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-form
              :ref="'item' + index"
              :model="item"
              :rules="itemRules"
              label-position="right"
              label-width="150px"
            >
              <el-row :class="{ show: item.modified, hide: !item.modified }">
                <el-col :span="8">
                  <el-form-item label="开始时间：" prop="editableStartDate">
                    <el-date-picker
                      v-model="item.editableStartDate"
                      type="date"
                      placeholder="请选择"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="终止时间：" prop="editableEndDate">
                    <el-date-picker
                      v-model="item.editableEndDate"
                      type="date"
                      placeholder="请选择"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="地点：" prop="editableLocation">
                    <el-input
                      v-model="item.editableLocation"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="工作培训学习内容："
                    prop="editableContent"
                  >
                    <el-input
                      type="textarea"
                      v-model="item.editableContent"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="10">
                  <el-button type="primary" @click="save(item, index)"
                    >保存</el-button
                  >
                </el-col>
              </el-row>
            </el-form>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.show {
  display: block;
}
.hide {
  display: none;
}
.modify {
  color: #2a8ae0;
  &:hover {
    cursor: pointer;
  }
}
.delete {
  color: #ff5858;
  &:hover {
    cursor: pointer;
  }
}
</style>
<script>
import partHeader from "./partHeader.vue";
export default {
  props: {
    resumeList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    partHeader
  },
  data() {
    return {
      title: "工作及培训学习简历",
      form: {
        resume: [
          //工作及培训学习简历
          // {
          //     startDate: "2021-01-01",
          //     endDate: "2020-02-02",
          //     location: "安徽大学",
          //     content: "工作学习培训内容工作学习培训内容工作学习培训内容工作学习培训内容工作学习培训内容",
          //     modified: false,
          //     show: true,
          // }
        ]
      },
      rules: {
        resume: [
          {
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                return callback(new Error("请添加工作培训学习简历"));
              }
              for (let i = 0; i < value.length; i++) {
                if (value[i].modified == true) {
                  return callback(new Error("请保存工作培训学习简历"));
                }
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      itemRules: {
        editableStartDate: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],
        editableEndDate: [
          { required: true, message: "请选择结束时间", trigger: "blur" }
        ],
        editableLocation: [
          { required: true, message: "请填写地点", trigger: "blur" }
        ],
        editableContent: [
          {
            required: true,
            message: "请填写工作培训学习内容",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    if (this.resumeList && this.resumeList.length > 0) {
      //TODO 添加editable对应的属性
      this.form.resume = this.resumeList;
    }
  },
  mounted() {
    if (!this.$route.params.isTj) {
      this.form.resume = this.item.dsgzpxxxjl.map(item => {
        return {
          gzpxxxjlid: item.gzpxxxjlid,
          startDate: item.ksrq,
          endDate: item.jsrq,
          location: item.dd,
          content: item.nr,
          show: true,
          modified: false,
          editableStartDate: item.ksrq,
          editableEndDate: item.jsrq,
          editableLocation: item.dd,
          editableContent: item.nr
        };
      });
    }
  },
  methods: {
    del(index) {
      this.form.resume.splice(index, 1);
    },
    save(item, index) {
      let key = "item" + index;
      this.$refs[key][0].validate(valid => {
        if (valid) {
          item.startDate = item.editableStartDate;
          item.endDate = item.editableEndDate;
          item.location = item.editableLocation;
          item.content = item.editableContent;
          item.modified = false;
          item.show = true;
        }
      });
    },
    modify(item) {
      item.modified = true;
    },
    add() {
      // this.validate();
      let item = {
        gzpxxxjlid: "",
        startDate: "",
        endDate: "",
        location: "",
        content: "",
        show: false,
        modified: true,
        editableStartDate: "",
        editableEndDate: "",
        editableLocation: "",
        editableContent: ""
      };
      this.form.resume.push(item);
    },
    validate() {
      this.validateForm();
      if (this.validated) {
        let para = {
          data_gzpxxxjl: []
        };
        let resume = this.form.resume;
        for (let i = 0; i < resume.length; i++) {
          let item = {
            gzpxxxjlid: resume[i].gzpxxxjlid, //id
            ksrq: resume[i].startDate, //开始日期
            jsrq: resume[i].endDate, //结束日期
            dd: resume[i].location, //地点
            nr: resume[i].content //内容
          };
          para.data_gzpxxxjl.push(item);
        }
        para.data_gzpxxxjl = JSON.stringify(para.data_gzpxxxjl);
        return para;
      }
      return null;
    },
    validateForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.validated = true;
        } else {
          this.validated = false;
        }
      });
    },
    reset() {
      this.form.resume = [];
    }
  }
};
</script>
